// Copy paste of a hook from @confluence/editor-features
// Can't use it directly because editor-features imports share-and-restrict-dialog
// Into a circular dependency.
import { useState, useEffect } from 'react';

export const useDocumentActive = (): boolean => {
	// eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
	const [isActive, setIsActive] = useState<boolean>(document?.visibilityState === 'visible');

	/**
	 * 8 seconds delay to change to isActive when document becomes visible again..
	 *
	 * It used to be 2, but we're running into a lot of session expired errors
	 * when running the query right after isActive becomes true.
	 *
	 * The hope is the longer delay will allows us to "wait it out", let some other queries rerun
	 * and get the session restored.
	 */
	const delay = 8000;

	useEffect(() => {
		let timer: NodeJS.Timeout;

		const handleVisibilityChange = () => {
			clearTimeout(timer);

			if (document?.visibilityState === 'visible') {
				timer = setTimeout(() => {
					setIsActive(true);
				}, delay);
			} else {
				setIsActive(false);
			}
		};

		document?.addEventListener('visibilitychange', handleVisibilityChange);

		return () => {
			clearTimeout(timer);
			document?.removeEventListener('visibilitychange', handleVisibilityChange);
		};
	}, []);

	return isActive;
};
